import { render, staticRenderFns } from "./InspectComment.vue?vue&type=template&id=638c57df&"
import script from "./InspectComment.vue?vue&type=script&lang=ts&"
export * from "./InspectComment.vue?vue&type=script&lang=ts&"
import style0 from "./InspectComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InspectComment.vue"
export default component.exports